export class DocumentCreator {
    id: string;
    description: string;
    content: string;
    title: string;
    module: string;

}
